import { render } from "./Volantes.vue?vue&type=template&id=3f1b17fe&scoped=true"
import script from "./Volantes.vue?vue&type=script&lang=js"
export * from "./Volantes.vue?vue&type=script&lang=js"

import "./Volantes.vue?vue&type=style&index=0&id=3f1b17fe&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1b17fe"]])

export default __exports__